import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
export default class TaldezainaNotificationsPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "matches", []);
    _defineProperty(this, "loadingMatches", true);
    // Reminder form
    _defineProperty(this, "reminderMatchId", 0);
    _defineProperty(this, "sendingReminder", false);
    // Custom notification form
    _defineProperty(this, "targetGroup", 'lineup_pending');
    _defineProperty(this, "customMatchId", 0);
    _defineProperty(this, "customTitle", '');
    _defineProperty(this, "customDescription", '');
    _defineProperty(this, "customUrl", 'https://aurreraathletic.eu/');
    _defineProperty(this, "sendingCustom", false);
    // Polls selection for custom notification
    _defineProperty(this, "selectedPolls", []);
    _defineProperty(this, "pollSearchText", '');
    _defineProperty(this, "pollSuggestions", []);
    _defineProperty(this, "loadingPolls", false);
    _defineProperty(this, "showPollDropdown", false);
    _defineProperty(this, "searchPollsTimeout", null);
    _defineProperty(this, "handleClickOutside", e => {
      const target = e.target;
      if (target && !target.closest('.PollSearchContainer')) {
        this.showPollDropdown = false;
        m.redraw();
      }
    });
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    document.addEventListener('click', this.handleClickOutside);
  }
  onremove(vnode) {
    super.onremove(vnode);
    document.removeEventListener('click', this.handleClickOutside);
  }
  loadPolls(query) {
    if (query === void 0) {
      query = '';
    }
    this.loadingPolls = true;
    m.redraw();
    const url = app.forum.attribute('apiUrl') + '/nagusi/admin/polls' + (query ? '?q=' + encodeURIComponent(query) : '');
    app.request({
      method: 'GET',
      url: url
    }).then(res => {
      this.pollSuggestions = res && res.data ? res.data : [];
    }).catch(err => {
      console.error('Error loading polls:', err);
    }).finally(() => {
      this.loadingPolls = false;
      m.redraw();
    });
  }
  onPollSearchInput(text) {
    this.pollSearchText = text;
    this.showPollDropdown = true;
    if (this.searchPollsTimeout) {
      clearTimeout(this.searchPollsTimeout);
    }
    this.searchPollsTimeout = setTimeout(() => {
      this.loadPolls(this.pollSearchText.trim());
    }, 250);
  }
  selectPoll(poll) {
    if (!poll || !poll.id) return;
    const exists = this.selectedPolls.some(p => p.id === poll.id);
    if (!exists) {
      this.selectedPolls.push(poll);
      this.updateUrlForPolls();
    }
    this.pollSearchText = '';
    this.showPollDropdown = false;
    m.redraw();
  }
  removePoll(pollId) {
    this.selectedPolls = this.selectedPolls.filter(p => p.id !== pollId);
    this.updateUrlForPolls();
    m.redraw();
  }
  updateUrlForPolls() {
    const baseUrl = (app.forum.attribute('baseUrl') || window.location.origin).replace(/\/$/, '');
    if (this.selectedPolls.length > 0) {
      const firstPoll = this.selectedPolls[0];
      if (firstPoll.discussion_id) {
        const slugPart = firstPoll.discussion_slug ? "-".concat(firstPoll.discussion_slug) : '';
        this.customUrl = "".concat(baseUrl, "/d/").concat(firstPoll.discussion_id).concat(slugPart);
      }
    }
  }
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.session.user || !app.session.user.isAdmin()) {
      m.route.set('/');
      return;
    }
    this.loadMatches();
  }
  loadMatches() {
    this.loadingMatches = true;
    m.redraw();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/matches?include=rival,season&upcoming=1'
    }).then(res => {
      const rawMatches = app.store.pushPayload(res);
      const matchesArr = Array.isArray(rawMatches) ? rawMatches : [rawMatches];
      const now = new Date().getTime();
      const validMatches = matchesArr.filter(matchItem => matchItem && typeof matchItem.id === 'function' && matchItem.id());

      // Filter upcoming matches (from 4h in past to future)
      let upcoming = validMatches.filter(matchItem => {
        const matchTime = matchItem.matchDate() ? new Date(matchItem.matchDate()).getTime() : 0;
        return matchTime >= now - 4 * 3600 * 1000;
      });

      // Sort ascending by date (closest upcoming match first)
      upcoming.sort((a, b) => {
        const dateA = a.matchDate() ? new Date(a.matchDate()).getTime() : 0;
        const dateB = b.matchDate() ? new Date(b.matchDate()).getTime() : 0;
        return dateA - dateB;
      });
      if (upcoming.length > 0) {
        this.matches = upcoming.slice(0, 3);
      } else {
        // Fallback: 3 most recent matches if no future matches exist
        validMatches.sort((a, b) => {
          const dateA = a.matchDate() ? new Date(a.matchDate()).getTime() : 0;
          const dateB = b.matchDate() ? new Date(b.matchDate()).getTime() : 0;
          return dateB - dateA;
        });
        this.matches = validMatches.slice(0, 3);
      }
      if (this.matches.length > 0) {
        this.reminderMatchId = parseInt(this.matches[0].id());
        this.customMatchId = parseInt(this.matches[0].id());
      }
    }).catch(err => {
      console.error('Error loading matches:', err);
      app.alerts.show({
        type: 'error'
      }, 'Error al cargar el listado de partidos.');
    }).finally(() => {
      this.loadingMatches = false;
      m.redraw();
    });
  }
  formatMatchLabel(matchItem) {
    if (!matchItem) return '';
    const rival = matchItem.rival ? matchItem.rival() : null;
    const rivalName = rival && typeof rival.name === 'function' && rival.name() ? rival.name() : matchItem.opponent && typeof matchItem.opponent === 'function' && matchItem.opponent() ? matchItem.opponent() : 'Rival';
    const isLocal = matchItem.isLocal && typeof matchItem.isLocal === 'function' ? matchItem.isLocal() : true;
    const vsText = isLocal ? 'Athletic vs ' + rivalName : rivalName + ' vs Athletic';
    const jornadaVal = matchItem.jornada && typeof matchItem.jornada === 'function' ? matchItem.jornada() : '';
    let jornadaPrefix = '';
    if (jornadaVal) {
      const rawJ = String(jornadaVal).trim();
      jornadaPrefix = (rawJ.toLowerCase().startsWith('j') ? rawJ : 'Jornada ' + rawJ) + ': ';
    }
    const rawDate = matchItem.matchDate && typeof matchItem.matchDate === 'function' ? matchItem.matchDate() : null;
    let dateStr = '';
    if (rawDate) {
      const d = new Date(rawDate);
      if (!isNaN(d.getTime())) {
        dateStr = ' (' + d.toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        }) + ')';
      }
    }
    return jornadaPrefix + vsText + dateStr;
  }
  getClosingDeadlineStr(matchId) {
    const match = this.matches.find(m => parseInt(m.id()) === matchId);
    if (!match || !match.matchDate || !match.matchDate()) return '2h antes del partido';
    const d = new Date(match.matchDate());
    if (isNaN(d.getTime())) return '2h antes del partido';
    d.setHours(d.getHours() - 2);
    return d.toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
  sendReminder() {
    if (!this.reminderMatchId) {
      app.alerts.show({
        type: 'error'
      }, 'Por favor selecciona un partido.');
      return;
    }
    this.sendingReminder = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/admin/notifications/send-reminder',
      body: {
        match_id: this.reminderMatchId
      }
    }).then(() => {
      app.alerts.show({
        type: 'success'
      }, 'Recordatorios de Bolilla y 11 Aldeanos enviados a los usuarios pendientes.');
    }).catch(err => {
      console.error(err);
      app.alerts.show({
        type: 'error'
      }, err && err.response && err.response.error || 'Error al enviar recordatorios.');
    }).finally(() => {
      this.sendingReminder = false;
      m.redraw();
    });
  }
  sendCustomNotification() {
    if (!this.customTitle.trim() || !this.customDescription.trim()) {
      app.alerts.show({
        type: 'error'
      }, 'Por favor introduce un título y una descripción.');
      return;
    }
    if (this.targetGroup === 'poll_pending' && this.selectedPolls.length === 0) {
      app.alerts.show({
        type: 'error'
      }, 'Por favor selecciona al menos una encuesta para filtrar los destinatarios.');
      return;
    }
    if ((this.targetGroup === 'lineup_pending' || this.targetGroup === 'bolilla_pending') && !this.customMatchId) {
      app.alerts.show({
        type: 'error'
      }, 'Por favor selecciona un partido para filtrar los usuarios pendientes.');
      return;
    }
    this.sendingCustom = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/admin/notifications/send-custom',
      body: {
        match_id: this.targetGroup === 'all' || this.targetGroup === 'poll_pending' ? 0 : this.customMatchId,
        poll_ids: this.targetGroup === 'poll_pending' ? this.selectedPolls.map(p => p.id) : [],
        target_group: this.targetGroup,
        title: this.customTitle,
        description: this.customDescription,
        url: this.customUrl || 'https://aurreraathletic.eu/'
      }
    }).then(res => {
      const count = res && typeof res.count === 'number' ? res.count : 0;
      app.alerts.show({
        type: 'success'
      }, "Notificaci\xF3n personalizada enviada con \xE9xito (".concat(count, " usuarios destinatarios)."));
      this.customTitle = '';
      this.customDescription = '';
      this.selectedPolls = [];
      this.pollSearchText = '';
      this.pollSuggestions = [];
    }).catch(err => {
      console.error(err);
      app.alerts.show({
        type: 'error'
      }, err && err.response && err.response.error || 'Error al enviar la notificación.');
    }).finally(() => {
      this.sendingCustom = false;
      m.redraw();
    });
  }
  view() {
    if (!app.session.user || !app.session.user.isAdmin()) return null;
    return m("div", {
      className: "TaldezainaNotificationsPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 40px; max-width: 850px;"
    }, m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px;"
    }, m(Link, {
      href: "/taldezaina",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), "Volver a Taldezainak")), m("div", {
      style: "margin-bottom: 35px;"
    }, m("h2", {
      style: "font-size: 2.2em; font-weight: 800; color: var(--heading-color); margin: 0;"
    }, "\uD83D\uDD14 Gesti\xF3n de Notificaciones"), m("p", {
      style: "color: var(--muted-color); font-size: 1.1em; margin-top: 8px;"
    }, "Env\xEDa recordatorios de partidos o notificaciones personalizadas Push y Foro a la comunidad.")), m("div", {
      className: "Form-group",
      style: "background: rgba(255, 255, 255, 0.04); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 16px; padding: 25px; margin-bottom: 35px;"
    }, m("h3", {
      style: "font-size: 1.4em; font-weight: 700; color: var(--heading-color); margin-top: 0; margin-bottom: 15px;"
    }, "\u26BD Lanzar Recordatorio de Partido (Bolilla y 11 Aldeanos)"), m("p", {
      style: "color: var(--muted-color); margin-bottom: 20px; font-size: 0.95em;"
    }, "Se enviar\xE1 la notificaci\xF3n de 11 Aldeanos y La Bolilla \xFAnicamente a los usuarios que ", m("strong", null, "a\xFAn no hayan completado"), " sus pron\xF3sticos para el partido seleccionado. En la notificaci\xF3n se especificar\xE1 la fecha/hora exacta de cierre del plazo."), m("div", {
      className: "Form-group",
      style: "margin-bottom: 20px;"
    }, m("label", {
      style: "display: block; font-weight: bold; margin-bottom: 8px;"
    }, "Seleccionar Partido:"), m("select", {
      className: "FormControl",
      value: String(this.reminderMatchId),
      onchange: e => {
        this.reminderMatchId = parseInt(e.target.value);
        m.redraw();
      },
      disabled: this.loadingMatches || this.matches.length === 0,
      style: "width: 100%; border-radius: 8px;"
    }, this.matches.map(matchItem => m("option", {
      key: matchItem.id(),
      value: String(matchItem.id())
    }, this.formatMatchLabel(matchItem))))), this.reminderMatchId > 0 && m("div", {
      style: "background: rgba(255, 193, 7, 0.1); border-left: 4px solid #ffc107; padding: 12px 16px; border-radius: 6px; margin-bottom: 20px; font-size: 0.9em; color: var(--text-color);"
    }, m("i", {
      className: "fas fa-clock",
      style: "margin-right: 8px;"
    }), "Cierre del plazo para este partido: ", m("strong", null, this.getClosingDeadlineStr(this.reminderMatchId)), " (2 horas antes del partido)."), m(Button, {
      className: "Button Button--primary",
      loading: this.sendingReminder,
      disabled: this.loadingMatches || !this.reminderMatchId,
      onclick: () => this.sendReminder(),
      style: "font-weight: bold; border-radius: 8px; padding: 12px 20px;"
    }, m("i", {
      className: "fas fa-paper-plane",
      style: "margin-right: 8px;"
    }), "Enviar Recordatorios a Usuarios Pendientes")), m("div", {
      className: "Form-group",
      style: "background: rgba(255, 255, 255, 0.04); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 16px; padding: 25px;"
    }, m("h3", {
      style: "font-size: 1.4em; font-weight: 700; color: var(--heading-color); margin-top: 0; margin-bottom: 15px;"
    }, "\uD83D\uDCE2 Enviar Notificaci\xF3n Personalizada"), m("p", {
      style: "color: var(--muted-color); margin-bottom: 20px; font-size: 0.95em;"
    }, "Permite enviar un mensaje personalizado Push y Foro a un grupo espec\xEDfico de destinatarios."), m("div", {
      className: "Form-group",
      style: "margin-bottom: 20px;"
    }, m("label", {
      style: "display: block; font-weight: bold; margin-bottom: 8px;"
    }, "P\xFAblico Destinatario:"), m("select", {
      className: "FormControl",
      value: this.targetGroup,
      onchange: e => {
        this.targetGroup = e.target.value;
        if (this.targetGroup === 'poll_pending') {
          if (this.pollSuggestions.length === 0) {
            this.loadPolls('');
          }
          if (this.selectedPolls.length > 0) {
            this.updateUrlForPolls();
          }
        }
        m.redraw();
      },
      style: "width: 100%; border-radius: 8px;"
    }, m("option", {
      value: "lineup_pending"
    }, "11 aldeanos sin rellenar"), m("option", {
      value: "bolilla_pending"
    }, "Bolilla sin rellenar"), m("option", {
      value: "poll_pending"
    }, "Encuesta(s) sin responder"), m("option", {
      value: "all"
    }, "Todos"))), (this.targetGroup === 'lineup_pending' || this.targetGroup === 'bolilla_pending') && m("div", {
      className: "Form-group",
      style: "margin-bottom: 20px;"
    }, m("label", {
      style: "display: block; font-weight: bold; margin-bottom: 8px;"
    }, "Partido de referencia:"), m("select", {
      className: "FormControl",
      value: String(this.customMatchId),
      onchange: e => {
        this.customMatchId = parseInt(e.target.value);
        m.redraw();
      },
      disabled: this.loadingMatches || this.matches.length === 0,
      style: "width: 100%; border-radius: 8px;"
    }, this.matches.map(matchItem => m("option", {
      key: matchItem.id(),
      value: String(matchItem.id())
    }, this.formatMatchLabel(matchItem))))), this.targetGroup === 'poll_pending' && m("div", {
      className: "Form-group PollSearchContainer",
      style: "margin-bottom: 20px; position: relative;"
    }, m("label", {
      style: "display: block; font-weight: bold; margin-bottom: 8px;"
    }, m("i", {
      className: "fas fa-poll-h",
      style: "margin-right: 6px; color: #ff9800;"
    }), "Encuesta(s) de referencia:"), this.selectedPolls.length > 0 && m("div", {
      style: "display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 12px;"
    }, this.selectedPolls.map(poll => m("div", {
      key: poll.id,
      style: "display: inline-flex; align-items: center; gap: 8px; background: rgba(255, 152, 0, 0.15); border: 1px solid rgba(255, 152, 0, 0.35); border-radius: 20px; padding: 6px 14px; font-size: 0.9em; color: var(--text-color);"
    }, m("i", {
      className: "fas fa-chart-bar",
      style: "color: #ff9800; font-size: 0.85em;"
    }), m("span", {
      style: "font-weight: 600; max-width: 300px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
    }, poll.question), poll.discussion_title && m("span", {
      style: "background: rgba(255, 255, 255, 0.1); border-radius: 10px; padding: 2px 8px; font-size: 0.78em; color: var(--muted-color); max-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
    }, poll.discussion_title), m("i", {
      className: "fas fa-times-circle",
      style: "cursor: pointer; color: var(--muted-color); font-size: 1.1em; transition: color 0.2s;",
      onmouseover: e => e.target.style.color = '#ff5252',
      onmouseout: e => e.target.style.color = 'var(--muted-color)',
      onclick: () => this.removePoll(poll.id),
      title: "Quitar encuesta"
    })))), m("div", {
      style: "position: relative;"
    }, m("div", {
      style: "position: relative; display: flex; align-items: center;"
    }, m("i", {
      className: "fas fa-search",
      style: "position: absolute; left: 14px; color: var(--muted-color); font-size: 0.95em;"
    }), m("input", {
      type: "text",
      className: "FormControl",
      value: this.pollSearchText,
      placeholder: "Buscar encuesta por pregunta o t\xEDtulo del hilo...",
      oninput: e => this.onPollSearchInput(e.target.value),
      onfocus: () => {
        this.showPollDropdown = true;
        if (this.pollSuggestions.length === 0) {
          this.loadPolls(this.pollSearchText.trim());
        }
      },
      style: "padding-left: 38px; padding-right: 38px; border-radius: 8px; width: 100%;"
    }), this.pollSearchText.trim() && m("i", {
      className: "fas fa-times-circle",
      style: "position: absolute; right: 14px; color: var(--muted-color); cursor: pointer; font-size: 1.05em;",
      onclick: () => {
        this.pollSearchText = '';
        this.loadPolls('');
      }
    })), this.showPollDropdown && m("div", {
      style: "position: absolute; top: calc(100% + 4px); left: 0; right: 0; z-index: 1000; background: #252830; border: 1px solid rgba(255, 255, 255, 0.15); border-radius: 8px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5); max-height: 280px; overflow-y: auto;"
    }, this.loadingPolls ? m("div", {
      style: "padding: 14px; text-align: center; color: var(--muted-color); font-size: 0.9em;"
    }, m("i", {
      className: "fas fa-spinner fa-spin",
      style: "margin-right: 8px;"
    }), "Buscando encuestas...") : this.pollSuggestions.length === 0 ? m("div", {
      style: "padding: 14px; text-align: center; color: var(--muted-color); font-size: 0.9em;"
    }, "No se encontraron encuestas.") : m("ul", {
      style: "list-style: none; margin: 0; padding: 4px 0;"
    }, this.pollSuggestions.map(poll => {
      const isSelected = this.selectedPolls.some(p => p.id === poll.id);
      return m("li", {
        key: poll.id,
        style: "padding: 10px 14px; cursor: ".concat(isSelected ? 'default' : 'pointer', "; border-bottom: 1px solid rgba(255, 255, 255, 0.05); color: #fff; font-size: 0.93em; transition: background 0.15s; display: flex; align-items: center; justify-content: space-between; ").concat(isSelected ? 'opacity: 0.5; background: rgba(255,255,255,0.02);' : ''),
        onclick: () => {
          if (!isSelected) {
            this.selectPoll(poll);
          }
        },
        oncreate: vn => {
          if (!isSelected) {
            const el = vn.dom;
            el.addEventListener('mouseenter', () => el.style.background = 'rgba(255, 255, 255, 0.08)');
            el.addEventListener('mouseleave', () => el.style.background = 'transparent');
          }
        }
      }, m("div", {
        style: "display: flex; flex-direction: column; gap: 4px; overflow: hidden; padding-right: 12px;"
      }, m("span", {
        style: "font-weight: bold; color: var(--heading-color); white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
      }, poll.question), m("div", {
        style: "display: flex; align-items: center; gap: 8px; font-size: 0.82em; color: var(--muted-color);"
      }, poll.discussion_title && m("span", null, m("i", {
        className: "fas fa-comments",
        style: "margin-right: 4px;"
      }), poll.discussion_title), m("span", null, m("i", {
        className: "fas fa-vote-yea",
        style: "margin-right: 4px;"
      }), poll.vote_count || 0, " votos"))), isSelected ? m("span", {
        style: "color: #4caf50; font-size: 0.85em; font-weight: bold; display: flex; align-items: center; gap: 4px; flex-shrink: 0;"
      }, m("i", {
        className: "fas fa-check"
      }), " Seleccionada") : m("span", {
        style: "color: #ff9800; font-size: 0.82em; font-weight: 600; flex-shrink: 0;"
      }, "+ A\xF1adir"));
    })))), m("p", {
      style: "color: var(--muted-color); font-size: 0.88em; margin-top: 8px; margin-bottom: 0;"
    }, m("i", {
      className: "fas fa-info-circle",
      style: "margin-right: 5px;"
    }), "Los destinatarios ser\xE1n los usuarios que ", m("strong", null, "no han respondido a alguna"), " de las encuestas seleccionadas. La URL por defecto apuntar\xE1 al hilo de la primera encuesta seleccionada.")), m("div", {
      className: "Form-group",
      style: "margin-bottom: 20px;"
    }, m("label", {
      style: "display: block; font-weight: bold; margin-bottom: 8px;"
    }, "T\xEDtulo:"), m("input", {
      type: "text",
      className: "FormControl",
      value: this.customTitle,
      oninput: e => this.customTitle = e.target.value,
      placeholder: "Ej: \xA1Nuevo partido disponible!",
      style: "width: 100%; border-radius: 8px;"
    })), m("div", {
      className: "Form-group",
      style: "margin-bottom: 20px;"
    }, m("label", {
      style: "display: block; font-weight: bold; margin-bottom: 8px;"
    }, "Descripci\xF3n:"), m("textarea", {
      className: "FormControl",
      rows: 3,
      value: this.customDescription,
      oninput: e => this.customDescription = e.target.value,
      placeholder: "Escribe aqu\xED el contenido de la notificaci\xF3n...",
      style: "width: 100%; border-radius: 8px;"
    })), m("div", {
      className: "Form-group",
      style: "margin-bottom: 25px;"
    }, m("label", {
      style: "display: block; font-weight: bold; margin-bottom: 8px;"
    }, "URL de destino (al hacer clic):"), m("input", {
      type: "url",
      className: "FormControl",
      value: this.customUrl,
      oninput: e => this.customUrl = e.target.value,
      placeholder: "https://aurreraathletic.eu/",
      style: "width: 100%; border-radius: 8px;"
    })), m(Button, {
      className: "Button Button--primary",
      loading: this.sendingCustom,
      onclick: () => this.sendCustomNotification(),
      style: "font-weight: bold; border-radius: 8px; padding: 12px 20px;"
    }, m("i", {
      className: "fas fa-paper-plane",
      style: "margin-right: 8px;"
    }), "Enviar Notificaci\xF3n Personalizada"))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/TaldezainaNotificationsPage', TaldezainaNotificationsPage);